import { createSlice } from "@reduxjs/toolkit";
import {
  sharedExtraReducers,
  sharedInitialState,
  sharedReducers,
} from "./shared";
import type { SharedProps } from "./shared";

// Not exported — matches the apps.
interface Props extends SharedProps {}

const initialState: Props = {
  ...sharedInitialState,
};

export const RecommenderSlice = createSlice({
  name: "recommender",
  initialState,
  reducers: {
    ...sharedReducers,
  },
  // Shared too — both platforms clear the recommender config on logout. See ./shared.ts.
  extraReducers: sharedExtraReducers,
});

export const {
  getRecommenderConfig,
  saveRecommenderConfig,
  recommenderConfigCallComplete,
  getRecommendations,
  getRecommendationsV2,
  saveRecommendations,
  saveRecommendationsFailed,
} = RecommenderSlice.actions;

export default RecommenderSlice.reducer;
